import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Tooltip,
  Popover,
  Button,
  Row,
  notification,
  Modal,
  DatePicker,
  Space,
} from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import SearchDatePicker from "../../components/search/datePicker";
import SearchPaymentMethod from "../../components/search/searchPaymentMethod";
import GetAdminInvoices from "../../functions/admin/getAdminInvoices";
import ExportAdminInvoices from "../../functions/admin/exportAdminInvoices";
import { downloadAdminInvoiceExcel } from "../../functions/admin/buildAdminInvoiceExcel";
import SearchAdminByMerchant from "../../components/search/searchAdminByMerchant";
import axios from "axios";
import {
  CodeOutlined,
  FilterOutlined,
  LinkOutlined,
  RedoOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { useAdmin } from "../../context/adminContext";
import moneyFormat from "../../functions/utils/moneyFormat";
import SearchAdmin from "../../components/search/searchAdmin";
import AdminInvoiceAdd from "../../components/modal/adminInvoiceAdd";
import { bg_button, bg_shadow } from "constant/css";
import TablePagination from "components/pagination/tablePagination";

const { RangePicker } = DatePicker;

const AdminInvoice = () => {
  const { showLoading, hideLoading } = useLoading();
  const { searchFields, setSearchFields, showFilter, setShowFilter } =
    useAdmin();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [devMode, setDevMode] = useState(false);

  const [summary, setSummary] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [excelModal, setExcelModal] = useState(false);
  const [excelRange, setExcelRange] = useState([
    dayjs().startOf("month"),
    dayjs().endOf("day"),
  ]);
  const [excelExporting, setExcelExporting] = useState(false);
  useEffect(() => {
    prepareQueryStringAndSearch();
  }, [searchFields, page, pageSize]);
  const prepareQueryStringAndSearch = () => {
    const searchFieldsLength = Object.keys(searchFields).length;
    var queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFields)
        .filter((key) => searchFields[key] != null && searchFields[key] !== "")
        .map((key) => {
          if (key.includes("At")) {
            const start = dayjs(searchFields[key][0])
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss");
            const end = dayjs(searchFields[key][1])
              .endOf("day")
              .format("YYYY-MM-DD HH:mm:ss");
            return `${key}=${encodeURIComponent(`${start}->${end}`)}`;
          }
          return `${key}=${encodeURIComponent(searchFields[key])}`;
        })
        .join("&");
    }
    fetchInvoices(queryString, page, pageSize);
  };
  const defaultColumns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 5,
    },
    {
      title: <SearchAdminByMerchant title="Мерчант" fieldName="merchantId" />,
      dataIndex: "merchant",
      key: "merchant",
      width: 50,
      render: (e) => (e ? e.name : "-"),
    },
    {
      title: (
        <SearchAdmin noSearch={true} title="Нийт дүн" fieldName="totalAmount" />
      ),
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (e) => moneyFormat(e),
      width: 50,
    },
    {
      title: (
        <SearchAdmin
          select={[
            { value: null, title: "Сонго" },
            { value: "PAID", title: "Төлөгдсөн" },
            { value: "NOT_PAID", title: "Төлөгдөөгүй" },
          ]}
          title="Төлөв"
          fieldName="status"
        />
      ),
      dataIndex: "status",
      key: "status",
      width: 100,
      align: "center",
      render: (e) =>
        e === "PAID" ? (
          <Tag color="cyan">Төлөгдсөн</Tag>
        ) : (
          <Tag color="default">Төлөөгүй</Tag>
        ),
    },
    {
      title: (
        <SearchDatePicker
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    // {
    //     title: <SearchDatePicker title='Шинэчлэгдсэн огноо' datePicker fieldName='updatedAt' />,
    //     dataIndex: 'updatedAt',
    //     key: 'updatedAt',
    //     width: 120,
    //     render: e => e ? dayjs(e).format('YYYY-MM-DD HH:mm:ss') : '-'
    // },
    {
      title: (
        <SearchPaymentMethod
          width={150}
          title="Төлсөн хэлбэр"
          fieldName="paymentMethodId"
        />
      ),
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      width: 80,
      render: (e) => (e ? e.name : "-"),
    },
    {
      title: (
        <SearchAdmin
          width={150}
          select={[
            { value: null, title: "Сонго" },
            { value: "SUCCESS", title: "200 OK" },
            { value: "502", title: "502" },
            { value: "FAILED", title: "Бусад" },
          ]}
          title="Мерчант дуудалт"
          fieldName="callBackResponse"
        />
      ),
      dataIndex: "callBackResponse",
      key: "callBackResponse",
      width: 100,
      align: "right",
      render: (e) => (e ? e : "-"),
    },
    {
      title: (
        <SearchAdmin
          width={150}
          select={[
            { value: null, title: "Сонго" },
            { value: "HAS_USER", title: "Төлөгчтэй" },
            { value: "NO_USER", title: "Хоосон" },
          ]}
          title="Төлөгч"
          fieldName="userId"
        />
      ),
      dataIndex: "user",
      key: "user",
      width: 100,
      render: (e) => (e ? e.phone : "-"),
    },
    {
      title: <span style={{ color: "red", fontSize: 10 }}>DEV BUTTONS!</span>,
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (e, r) => (
        <div>
          <Button className="smallButton" onClick={() => forcePay(r)}>
            PAY
          </Button>
          <Button className="smallButton" onClick={() => forcePayLocal(r)}>
            PAY LOCAL
          </Button>
          <Button
            className="smallButton"
            onClick={() => openInvoice(r)}
            icon={<LinkOutlined />}
          ></Button>
          <Button
            className="smallButton"
            onClick={() => openInvoiceLocal(r)}
            icon={<LinkOutlined style={{ color: "red" }} />}
          ></Button>
        </div>
      ),
    },
  ];
  const invoiceItemColumns = [
    {
      title: "Нийт дүн",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "НӨАТ",
      dataIndex: "invoiceItemVatInfo",
      key: "invoiceItemVatInfo",
      render: (e) =>
        e?.status == "DONE" ? (
          <Popover title="VAT" content={<p>{JSON.stringify(e.qrJson)}</p>}>
            <Tag color="cyan">Үүссэн</Tag>
          </Popover>
        ) : (
          <Tag color="default">Үүссэгүй</Tag>
        ),
    },
    {
      title: (
        <Tooltip title="Мерчант-с өгсөн хаягыг төлөгдсөний дараа дуудсан статус">
          <span>Мэдээлэлсэн ?</span>
        </Tooltip>
      ),
      dataIndex: "callBackResponse",
      key: "callBackResponse",
      render: (e) =>
        e ? (
          String(e).includes("200") ? (
            <Tag color="cyan">200</Tag>
          ) : (
            <Tag color="default">{e}</Tag>
          )
        ) : (
          <Tag color="default">-</Tag>
        ),
    },
    {
      title: "Огноо",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: "Бүт/төрөл",
      dataIndex: "productType",
      key: "productType",
      render: (e) => (e ? e.name : "-"),
    },
    {
      title: "Гүйлгээ",
      dataIndex: "transaction",
      key: "transaction",
      render: (e) => (e ? e.status : "-"),
    },
  ];
  const forcePay = async (record) => {
    var histories = record.qpayHistories;
    if (!histories || histories.length == 0) return;
    var sorted = histories.sort((a, b) => b.id - a.id);
    const qpayUrl = sorted[0].callBackUrl;
    if (!qpayUrl) return;
    axios
      .get(qpayUrl)
      .then((e) => {
        notification.success({
          message: "Success",
          description: "",
        });
      })
      .catch((e) => {
        if (e.response && e.response.data.error)
          notification.error({
            message: "Error",
            description: e.response.data.error.message,
          });
        else
          notification.error({
            message: "Error",
            description: "Failed to pay",
          });
      });
  };
  const forcePayLocal = async (record) => {
    var histories = record.qpayHistories;
    if (!histories || histories.length == 0)
      return notification.error({ message: "no history click link!" });
    var sorted = histories.sort((a, b) => b.id - a.id);
    var qpayUrl = sorted[0].callBackUrl;
    if (!qpayUrl)
      return notification.error({ message: "no history click link!" });
    qpayUrl = String(qpayUrl).replace(
      "https://apispay.esukh.mn",
      "http://localhost:8005"
    );
    axios
      .get(qpayUrl)
      .then((e) => {
        notification.success({
          message: "Success",
          description: "",
        });
      })
      .catch((e) => {
        if (e.response && e.response.data.error)
          notification.error({
            message: "Error",
            description: e.response.data.error.message,
          });
        else
          notification.error({
            message: "Error",
            description: "Failed to pay",
          });
      });
  };
  const openInvoice = async (record) => {
    window.open(`https://spay.esukh.mn/invoice?secureId=${record.secureId}`);
  };
  const openInvoiceLocal = async (record) => {
    window.open(`http://localhost:3000/invoice?secureId=${record.secureId}`);
  };
  useEffect(() => {
    refresh();
  }, []);
  const fetchInvoices = async (queryString, page, size) => {
    showLoading();
    const response = await GetAdminInvoices(
      `&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
      setSummary(response.summary);
    }
  };
  const changePage = (page) => {
    setPage(page);
  };
  const addInvoice = (value) => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const changeSize = (current, size) => {
    setPageSize(size);
  };
  const refresh = () => {
    setPage(1);
    setSearchFields({});
    fetchInvoices("", 1, pageSize);
  };
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };
  const toggleDev = () => {
    setDevMode(!devMode);
  };
  const openExcelModal = () => {
    if (searchFields?.createdAt?.[0] && searchFields?.createdAt?.[1]) {
      setExcelRange([
        dayjs(searchFields.createdAt[0]),
        dayjs(searchFields.createdAt[1]),
      ]);
    }
    setExcelModal(true);
  };
  const handleExcelExport = async () => {
    if (!excelRange?.[0] || !excelRange?.[1]) {
      notification.warning({ message: "Эхлэх/дуусах огноо сонгоно уу" });
      return;
    }
    const startDate = excelRange[0].startOf("day").format("YYYY-MM-DD");
    const endDate = excelRange[1].endOf("day").format("YYYY-MM-DD");
    setExcelExporting(true);
    showLoading();
    try {
      const response = await ExportAdminInvoices({
        startDate,
        endDate,
        merchantId: searchFields.merchantId || undefined,
        status: searchFields.status || undefined,
        paymentMethodId: searchFields.paymentMethodId || undefined,
        callBackResponse: searchFields.callBackResponse || undefined,
        userId: searchFields.userId || undefined,
      });
      if (!response?.success || !response?.data) {
        notification.error({
          message: response?.message || "Excel өгөгдөл авахад алдаа гарлаа",
        });
        return;
      }
      downloadAdminInvoiceExcel(response.data);
      notification.success({
        message: "Excel татагдлаа",
        description: `${response.data.totalCount || 0} нэхэмжлэл · сар бүрийн sheet`,
      });
      setExcelModal(false);
    } catch (err) {
      notification.error({
        message:
          err.response?.data?.message || err.message || "Excel алдаа гарлаа",
      });
    } finally {
      setExcelExporting(false);
      hideLoading();
    }
  };
  return (
    <div className="vatMerchantListontainer mt-3">
      <Row style={{ gap: 10 }}>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} ${bg_shadow} rounded-xl`}
            onClick={addInvoice}
          >
            Нэхэмжлэл үүсгэх
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} ${bg_shadow} rounded-xl`}
            icon={<FileExcelOutlined />}
            onClick={openExcelModal}
          >
            Excel
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} ${bg_shadow} rounded-xl`}
            onClick={refresh}
          >
            <RedoOutlined />
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type={"primary"}
            className={`spayDefaultButton ${bg_button} ${bg_shadow} ${
              !showFilter && "spayDefaultButtonInactive"
            }`}
            onClick={toggleFilter}
          >
            <FilterOutlined />
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type={"primary"}
            className={`spayDefaultButton ${bg_button} ${bg_shadow} ${
              !devMode && "spayDefaultButtonInactive"
            }`}
            onClick={toggleDev}
          >
            <CodeOutlined />
          </Button>
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={defaultColumns.filter((e) => {
            if (e.key == "action") return devMode;
            return true;
          })}
          rowKey={(record) => record.id}
          expandable={{
            expandedRowRender: (record) => (
              <Table
                columns={invoiceItemColumns}
                dataSource={record.invoiceItems}
                pagination={false}
              />
            ),
            expandIconColumnIndex: 0,
            rowExpandable: () => {
              return true;
            },
          }}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 38vh)",
          }}
          size="small"
          pagination={false}
          dataSource={data}
          summary={(pageData) => {
            return (
              <Table.Summary fixed>
                <Table.Summary.Row className="summaryRow">
                  <Table.Summary.Cell index={0} colSpan={2} align="right">
                    Нийт дүн:
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} colSpan={2} align="right">
                    {summary ? moneyFormat(summary.totalAmount) : 0}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        ></Table>
        <TablePagination
          paginationData={paginationData}
          page={page}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      {openModal && (
        <AdminInvoiceAdd
          open={openModal}
          close={closeModal}
          refresh={refresh}
        />
      )}
      <Modal
        title="Нэхэмжлэл — Excel (нягтлан)"
        open={excelModal}
        onCancel={() => !excelExporting && setExcelModal(false)}
        okText="Татах"
        cancelText="Болих"
        confirmLoading={excelExporting}
        onOk={handleExcelExport}
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <div className="text-sm text-gray-600">
            Огнооны хязгаараар бүх нэхэмжлэлийг татна. Хүснэгтийн шүүлт
            (мерчант, төлөв, төлбөрийн хэлбэр гэх мэт) идэвхтэй бол хамт
            хэрэглэнэ.
          </div>
          <RangePicker
            style={{ width: "100%" }}
            value={excelRange}
            onChange={(v) => setExcelRange(v)}
            allowClear={false}
          />
        </Space>
      </Modal>
    </div>
  );
};

export default AdminInvoice;
